import { render, staticRenderFns } from "./Live.vue?vue&type=template&id=ebffea80&scoped=true&"
import script from "./Live.vue?vue&type=script&lang=js&"
export * from "./Live.vue?vue&type=script&lang=js&"
import style0 from "./Live.vue?vue&type=style&index=0&id=ebffea80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebffea80",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Live.vue
// module id = null
// module chunks = 